import React from "react";

export function WhiteBubbleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="22"
      fill="none"
      viewBox="0 0 24 22"
    >
      <path
        fill="url(#paint0_linear_779_2141)"
        d="M15.253 1.579c-2.906 0-5.264 2.173-5.264 4.852 0 2.68 2.358 4.853 5.264 4.853s5.264-2.174 5.264-4.853-2.358-4.852-5.264-4.852z"
      ></path>
      <path
        fill="url(#paint1_linear_779_2141)"
        d="M6.223 11.753c-1.79 0-3.258 1.344-3.258 3.004s1.457 3.003 3.258 3.003c1.79 0 3.258-1.344 3.258-3.004s-1.468-3.003-3.258-3.003z"
      ></path>
      <path
        fill="url(#paint2_linear_779_2141)"
        d="M16.262 14.991c-1.517 0-2.75 1.137-2.75 2.535 0 1.398 1.233 2.534 2.75 2.534 1.516 0 2.749-1.136 2.749-2.534s-1.233-2.535-2.75-2.535z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_779_2141"
          x1="9.989"
          x2="20.517"
          y1="6.431"
          y2="6.431"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#6CE5FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_779_2141"
          x1="2.965"
          x2="9.481"
          y1="14.757"
          y2="14.757"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#6CE5FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_779_2141"
          x1="13.512"
          x2="19.011"
          y1="17.526"
          y2="17.526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#6CE5FF"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}